<div
  class="imageDs__cont imageDs__cont--{{size}}"
  [ngStyle]="{ width : widthImage, height: heightImage, borderRadius: borderRadius }">
  @if (unsuccessfulReplacement) {
    <div
      class="imageDs__cont__not-available imageDs__cont__not-available--{{size}}"
      [ngStyle]="{ width : widthImage, height: heightImage, borderRadius: borderRadius }">
      <app-ds-icon
        [icon]="imageNotAvailable"
        [size]="iconSize"
        [color]="iconFillColor.Light">
      </app-ds-icon>
    </div>
  } @else {
    <img
      class="imageDs__cont__image imageDs__cont__image--{{size}}"
      [loading]="'lazy'"
      [draggable]="false"
      [alt]="alt"
      [src]="imgSrc"
      [srcset]="srcSet ?? ''"
      [ngStyle]="{ width : widthImage, height: heightImage, objectFit: objectFit, borderRadius: borderRadius }"
      (error)="errorHandler()"
      (load)="loadHandler()">
  }
  @if (!imgIsLoaded && useLoader) {
    <div
      class="imageDs__cont__loading imageDs__cont__loading--{{size}}"
      [ngStyle]="{ width : widthImage, height: heightImage, borderRadius: borderRadius }">
      <app-ds-loader-ring
        [size]="iconSize + 'px'">
      </app-ds-loader-ring>
    </div>
  }
</div>
